<template>
  <Select v-model="categoryId"
    style="width:200px;"
    placeholder="请选择或输入查询"
    filterable
    clearable
    remote
    :remote-method="getCommodity"
    :loading="commodityLoading"
    @on-query-change="changeCategory"
    @on-change="categoryChange"
    @on-select="selectCommodity"
    @on-clear="clearCommodity"
    @on-open-change="openChange">
    <Option v-for="item in categories" :value="item.id" :key="item.id">{{ item.agentName }}</Option>
  </Select>
</template>

<script>
import api from '../../api'

export default {
  data () {
    return {
      categories: [],
      categoryId: '',
      queryData: [],
      loading: false,
      totalPage: 1,
      pageSize: 10,
      pageNum: 1,
      commodityLoading: false,
      queryCommodity: null,
      isClearCommodity: false,
      isSelectCommodity: false,
      isOpen: false
    }
  },
  methods: {
    getCategory () {
      let params = {}
      if (!this.isOpen) {
        params.agentName = this.queryCommodity
      }
      api.agent.agentList({
        ...params,
        // agentName: this.queryCommodity,
        pageNum: 1,
        pageSize: 999
      }).then(res => {
        this.categories = res.data.records.filter(d => d.useState === 1) || []
        // this.categories = res.data.records || []
      }).catch(err => {
        this.$Message.error(err.message || '获取供应商列表失败，请刷新重试！')
      })
    },
    getData () {
      if (this.isClearCommodity) {
        this.queryData = []
        return false
      }
      this.loading = true
      api.agent.agentCommodityList({
        agentId: this.categoryId,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      })
        .then((res) => {
          this.loading = false
          this.totalPage = +res.data.total
          this.queryData = res.data.records || []
          this.isSelectCommodity = false
        })
        .catch((err) => {
          this.loading = false
          this.$Message.error('获取供应商列表失败: ' + err.message)
        })
    },
    categoryChange () {
      this.pageNum = 1
      if (!this.isSelectCommodity) {
        this.getData()
      }
    },
    // 节流
    throttle (fn, delay, val) {
      clearTimeout(fn.timeoutId)
      fn.timeoutId = setTimeout(function () {
        fn.call(val)
      }, delay)
    },
    // 代理商输入
    changeCategory (val) {
      this.isOpen = true
      this.queryCommodity = val
      if (!this.isSelectCommodity) {
        this.throttle(this.getCategory, 500)
      }
    },
    // 远程获取代理商
    getCommodity () {
      // this.throttle(this.getCategory, 500)
    },
    // 选中
    selectCommodity (val) {
      this.categoryId = val.value
      this.isClearCommodity = false
      this.isSelectCommodity = true
      this.$emit('selectAgentSuccess', val)
    },
    // 清除代理商
    clearCommodity () {
      this.isClearCommodity = true
      this.$emit('selectAgentClear')
    },
    openChange (val) {
      if (val) {
        this.isOpen = true
        this.getCategory()
      } else {
        this.isOpen = false
      }
    }
  }
}
</script>
